import { render, staticRenderFns } from "./MyAccreditationPassForm.vue?vue&type=template&id=3a85624c&scoped=true&"
import script from "./MyAccreditationPassForm.vue?vue&type=script&lang=js&"
export * from "./MyAccreditationPassForm.vue?vue&type=script&lang=js&"
import style0 from "./MyAccreditationPassForm.vue?vue&type=style&index=0&id=3a85624c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a85624c",
  null
  
)

export default component.exports